export const RouterConfig = {
  root: "/",
};
